/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const citySearchDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	country: z.object({ id: z.string(), name: z.string() }),
	region: z.object({ id: z.string(), name: z.string() }).nullable(),
	primaryCity: z.string().nullable(),
})

export type CitySearchDataSchema = z.infer<typeof citySearchDataSchema>
